<!--Title Section-->
<app-title-jumbo title="Events" comment="Many events are focusing their effort on Factor Investing"></app-title-jumbo>

<div class="my-container">

  <!--News and Events Section-->
  <section class="section">
    <div class="container">
      <div class="offset-1 col-10">

        <!--Carousel Wrapper-->
        <div id="carousel-example-1" class="carousel slide carousel-fade" data-ride="carousel">
          <!--Slides-->
          <div class="carousel-inner" role="listbox">
            <div class="carousel-item active">
              <div class="view">
                <img class="d-block w-100 h-100" src="assets/img/news_events_1.png" alt="News Event">
                <div class="mask rgba-black-slight"></div>
              </div>
              <div class="carousel-caption text-left" style="height:300px">
                <div class="col-12 py-3 px-5 h-100" style="background: rgba(0,0,0,0.75)">
                  <app-title header="Forthcoming event" title="Factor Investing is being held to a new standard." priority="3"></app-title>

                  Factor Investing is transforming the way investors construct and manage portfolios. The increasing popularity of Factor Investing can create the need for standards. MSCI FaCS creates a common language for Factor Investing and brings clarity to the confusion of Smart Beta.

                  <br><br>
                  <em style="font-size: 0.8em;">21 March, 2019 – 3.00pm</em>

                  <div class="row">
                    <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Join and learn</app-line-button>
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="carousel-item">
              <div class="view">
                <img class="d-block w-100 h-100" src="assets/img/news_events_2.png" alt="News Event">
                <div class="mask rgba-black-slight"></div>
              </div>
              <div class="carousel-caption text-left" style="height:300px">
                <div class="col-12 py-3 px-5 h-100" style="background: rgba(0,0,0,0.75)">
                  <app-title header="News" title="How factor investing fits into active vs passive" priority="3"></app-title>

                  Why factor investing makes sense. Altaf Kassam, MSCI Head of Index Applied Research EMEAI. Factors are shown to outperform historically and their outperformance can be explained. It is suitable for passive and active investors.

                  <br><br>
                  <em style="font-size: 0.8em;">21 March, 2019 – 3.00pm</em>

                  <div class="row">
                    <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Join and learn</app-line-button>
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="carousel-item">
              <!--Mask color-->
              <div class="view">
                <img class="d-block w-100 h-100" src="assets/img/news_events_3.png" alt="News Event">
                <div class="mask rgba-black-slight"></div>
              </div>
              <div class="carousel-caption text-left" style="height:300px">
                <div class="col-12 py-3 px-5 h-100" style="background: rgba(0,0,0,0.75)">
                  <app-title header="Past event" title="Smart Beta Day Germany 2019" priority="3"></app-title>

                  The Smart Beta Day Germany 2019 will enable asset owners and their direct investment consultants and financial advisors to access...

                  <br><br>
                  <em style="font-size: 0.8em;">Frankfurt – 4 June, 2019</em>

                  <div class="row">
                    <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Join and learn</app-line-button>
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <div class="carousel-item">
              <!--Mask color-->
              <div class="view">
                <img class="d-block w-100 h-100" src="assets/img/news_events_4.png" alt="News Event">
                <div class="mask rgba-black-slight"></div>
              </div>
              <div class="carousel-caption text-left" style="height:300px">
                <div class="col-12 py-3 px-5 h-100" style="background: rgba(0,0,0,0.75)">
                  <app-title header="Past event" title="Risk Beta Days North America 2018" priority="3"></app-title>

                  This two-day conference will include multiple plenary sessions, workshops and practical sessions allowing professionals to review major...

                  <br><br>
                  <em style="font-size: 0.8em;">Boston – 25 & 26 October, 2018</em>

                  <div class="row">
                    <div class="col-10">
                      <span class="float-right">
                        <app-line-button green>Join and learn</app-line-button>
                      </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <!--/.Slides-->

          <!--Controls-->
          <a class="carousel-control-prev" href="#carousel-example-1" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carousel-example-1" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
          <!--/.Controls-->
        </div>
        <!--/.Carousel Wrapper-->
      </div>
    </div>
  </section>

</div>
